// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"tooltip__k7xax"};